var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4553 6.34252C9.95527 6.63119 9.95527 7.35283 9.45531 7.64149L5.98045 9.64771C5.48047 9.93637 4.85551 9.57554 4.85551 8.99822V4.9858C4.85551 4.40848 5.48047 4.04765 5.98045 4.33631L9.4553 6.34252ZM6.99268 0.242225C8.85622 0.242225 10.5438 0.997964 11.7654 2.21951C12.9869 3.44106 13.7426 5.12864 13.7426 6.99219C13.7426 8.85573 12.9869 10.5433 11.7654 11.7649C10.5438 12.9864 8.85622 13.7422 6.99268 13.7422C5.12913 13.7422 3.44155 12.9864 2.22 11.7649C0.998452 10.5433 0.242713 8.85573 0.242713 6.99219C0.242713 5.12864 0.998452 3.44106 2.22 2.21951C3.44155 0.997964 5.12913 0.242225 6.99268 0.242225ZM10.97 3.01484C9.95207 1.99689 8.54572 1.36715 6.99268 1.36715C5.43963 1.36715 4.03329 1.99689 3.01533 3.01484C1.99738 4.0328 1.36764 5.43915 1.36764 6.99219C1.36764 8.54523 1.99738 9.95158 3.01533 10.9695C4.03329 11.9875 5.43963 12.6172 6.99268 12.6172C8.54572 12.6172 9.95207 11.9875 10.97 10.9695C11.988 9.95158 12.6177 8.54523 12.6177 6.99219C12.6177 5.43915 11.988 4.0328 10.97 3.01484Z",
    fill: "#7043FF",
    stroke: "white",
    strokeWidth: 0.000075
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleIcon);
export default __webpack_public_path__ + "static/media/play_circle_icon.6af6eeffd165c635d9d985296ccb6c68.svg";
export { ForwardRef as ReactComponent };